export const GreenHS = () => {
  return (
    <div className="flex justify-center p-2 h-screen">
      <iframe
        className="p-4 h-screen w-screen"
        src="https://iframe.dacast.com/live/34722db9-4e7c-5b6a-03b1-492fb511cfd6/bcbb6100-7814-1d95-4331-0309746d2a81"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Green HS"
      />
    </div>
  );
};
